import { AUDIENCE_TYPE } from '../config';

const CONDITIONS_TRANSFORMER_TO_GW_PER_AUDIENCE = {
    [AUDIENCE_TYPE.BASIC]: audience => {
        return buildConditionToGW(audience);
    },
    [AUDIENCE_TYPE.ENGAGEMENT]: audience => audience.conditions,
};

const CONDITIONS_TRANSFORMER_FROM_GW_PER_AUDIENCE = {
    [AUDIENCE_TYPE.BASIC]: audience => {
        return buildConditionsArrayFromGW(audience.conditions);
    },
    [AUDIENCE_TYPE.ENGAGEMENT]: audience => audience.conditions,
    [AUDIENCE_TYPE.EVENT_BASED]: audience => audience.conditions,
};

const buildConditionFromGW = conditions => {
    return {
        predicate: conditions.predicate,
        url: conditions.value,
    };
};

const buildConditionsArrayFromGW = conditions => {
    if (!conditions.children || conditions.children.length === 0) {
        return [buildConditionFromGW(conditions)];
    }
    return conditions.children.map(c => buildConditionFromGW(c));
};

const buildUrlConditionToGW = conditions => {
    return {
        property: 'URL',
        predicate: conditions.predicate,
        value: conditions.url,
        children: [],
    };
};

const buildConditionsWithParentOrToGW = conditions => {
    const children = conditions.map(condition => buildUrlConditionToGW(condition));
    return {
        predicate: 'OR',
        children,
    };
};

const buildConditionToGW = audience => {
    if (!audience.conditions || audience.conditions.length < 1) {
        return {};
    }
    if (audience.conditions.length === 1) {
        return buildUrlConditionToGW(audience.conditions[0]);
    }
    return buildConditionsWithParentOrToGW(audience.conditions);
};

export const pixelBasedConditionsTransformerFromGW = audience => {
    const conditions =
        audience.type in CONDITIONS_TRANSFORMER_FROM_GW_PER_AUDIENCE
            ? CONDITIONS_TRANSFORMER_FROM_GW_PER_AUDIENCE[audience.type](audience)
            : {};

    return {
        ...audience,
        conditions,
    };
};

export const pixelBasedConditionsTransformerToGW = audience => {
    if (audience.conditions === undefined) {
        return audience;
    }

    const conditions =
        audience.type in CONDITIONS_TRANSFORMER_TO_GW_PER_AUDIENCE
            ? CONDITIONS_TRANSFORMER_TO_GW_PER_AUDIENCE[audience.type](audience)
            : {};

    return {
        ...audience,
        conditions,
    };
};
